import { isObject as Nt } from "../util/code-utils.js";
import {
  convertMsToSeconds as h,
  timestampOrNow as Jt,
} from "../util/date-utils.js";
export default class ue {
  constructor(t, i, s, r, e) {
    (this.userId = t),
      (this.type = i),
      (this.time = s),
      (this.sessionId = r),
      (this.data = e),
      (this.userId = t),
      (this.type = i),
      (this.time = Jt(s)),
      (this.sessionId = r),
      (this.data = e);
  }
  Gr() {
    const t = {
      name: this.type,
      time: h(this.time),
      data: this.data || {},
      session_id: this.sessionId,
      user_id: void 0,
    };
    return null != this.userId && (t.user_id = this.userId), t;
  }
  Y() {
    return {
      u: this.userId,
      t: this.type,
      ts: this.time,
      s: this.sessionId,
      d: this.data,
    };
  }
  static fromJson(t) {
    return new ue(t.user_id, t.name, t.time, t.session_id, t.data);
  }
  static cE(t) {
    return null != t && Nt(t) && null != t.t && "" !== t.t;
  }
  static En(t) {
    return new ue(t.u, t.t, t.ts, t.s, t.d);
  }
}
